import {
  useQuery,
} from 'react-query';

import middleman from 'helpers/middleman';

export const useTransactions = (portfolioUuid: string, status: string | undefined = undefined, type: string | undefined = undefined ) => useQuery(['transactions', portfolioUuid, status, type], () => {
  return middleman.promisePost(`/transactions/get/${portfolioUuid}`, { status, type, })
    .then(res => res.data);
}, { enabled: !!portfolioUuid, refetchOnWindowFocus: false});